import React from 'react';
import {useSelector} from 'react-redux';
import './RsDataModbus.css';

export default function RsDataModbus() {
    const parameter = useSelector((state) => state.dmimei?.data[0]);

    return(
        <div className='table-data-container'> 
            <table className='rs-data-table'>
            <thead >
                <tr>
                    <th>№ параметра</th>
                    <th>Величина</th>
                </tr>
            </thead>
            <tbody>
                <tr><td>1</td><td>{parameter?.param1}</td></tr>
                <tr><td>2</td><td>{parameter?.param2}</td></tr>
                <tr><td>3</td><td>{parameter?.param3}</td></tr>
                <tr><td>4</td><td>{parameter?.param4}</td></tr>
                <tr><td>5</td><td>{parameter?.param5}</td></tr>
                <tr><td>6</td><td>{parameter?.param6}</td></tr>
                <tr><td>7</td><td>{parameter?.param7}</td></tr>
                <tr><td>8</td><td>{parameter?.param8}</td></tr>
                <tr><td>9</td><td>{parameter?.param9}</td></tr>
                <tr><td>10</td><td>{parameter?.param10}</td></tr>
                <tr><td>11</td><td>{parameter?.param11}</td></tr>
                <tr><td>12</td><td>{parameter?.param12}</td></tr>
                <tr><td>13</td><td>{parameter?.param13}</td></tr>
                <tr><td>14</td><td>{parameter?.param14}</td></tr>
                <tr><td>15</td><td>{parameter?.param5}</td></tr>
                <tr><td>16</td><td>{parameter?.param16}</td></tr>
                <tr><td>17</td><td>{parameter?.param17}</td></tr>
                <tr><td>18</td><td>{parameter?.param18}</td></tr>
                <tr><td>19</td><td>{parameter?.param19}</td></tr>
                <tr><td>20</td><td>{parameter?.param20}</td></tr>
            </tbody>
            </table>
        </div>
    )
 }
